import React from "react";
import "./SideDrawer.css";
import { Link } from "react-router-dom";

const SideDrawer = ({ show, click }) => {
  const sideDrawerClass = ["sidedrawer"];

  if (show) {
    sideDrawerClass.push("show");
  }

  return (
    <div className={sideDrawerClass.join(" ")}>
      <div className="sidedrawer__links" onClick={click}>
        <a href="#projects">Works</a>
        <a href="#contact">Contact</a>

        {/* <p>
          <a href="/">Home</a>
        </p>

        <p>
          <a href="/about">About</a>
        </p>

        <p>
          <a href="/projects">Projects</a>
        </p>

        <p>
          <a href="/contact">Contact</a>
        </p> */}
      </div>
    </div>
  );
};

export default SideDrawer;
